import { MarkerMode, MarkerStyle } from "./type";

export function markerMode(props: MarkerMode): MarkerMode {
  return props;
}

export function markerStyle(props: MarkerStyle): MarkerStyle {
  return props;
}
